// generated by parseCompaniesCsv.js
// DO NOT EDIT MANUALLY. ONLY GENERATE USING 'npm run parse-companies'
/**** GEN:S id="companies-csv" */
export const companies = JSON.parse(`[
  {
    "companyName": "AEM Creations",
    "focuses": "Animation",
    "positionTypes": [
      "Interns",
      "Contract workers",
      "Freelancers"
    ],
    "website": "https://www.aem2create.com/",
    "interviews": "No",
    "virtualTimes": "All Day",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "https://www.aem2create.com/website-samples/images/logo.png"
  },
  {
    "companyName": "Netflix Feature Animation",
    "focuses": "Animation",
    "positionTypes": [
      ""
    ],
    "website": "https://www.netflixanimation.com/",
    "interviews": "Yes",
    "virtualTimes": "All Day",
    "inPersonTimes": "",
    "logoUrlCheckString": "https://brand.netflix.com/en/assets/logos"
  },
  {
    "companyName": "Deloitte",
    "focuses": "Graphic Design, UX/UI",
    "positionTypes": [
      "Full-time employees"
    ],
    "website": "https://www2.deloitte.com/us/en.html",
    "interviews": "No",
    "virtualTimes": "All Day",
    "inPersonTimes": "",
    "logoUrlCheckString": "It doesn't want to upload for me, but I'm happy to email you a logo!"
  },
  {
    "companyName": "Audience Media Group",
    "focuses": "Graphic Design, Marketing, Photography, Video Editing",
    "positionTypes": [
      "Interns",
      "Part-time employees"
    ],
    "website": "https://www.ataudience.com/",
    "interviews": "Yes",
    "virtualTimes": "10:00 - 10:30, 10:30 - 11:00, 11:00 - 11:30, 11:30 - 12:00, 12:30 - 1:00, 2:00 - 2:30, 3:00 - 3:30, 3:30 - 4:00",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "https://drive.google.com/file/d/1vD0FWGU6tqGDsUTCpPBOqFpRFEyEYMg2/view?usp=drive_link"
  },
  {
    "companyName": "TRG",
    "focuses": "Animation, Graphic Design",
    "positionTypes": [
      "Interns",
      "Full-time employees",
      "Part-time employees",
      "Contract workers",
      "Freelancers"
    ],
    "website": "https://trg.agency/",
    "interviews": "No",
    "virtualTimes": "All Day",
    "inPersonTimes": "",
    "logoUrlCheckString": "Yes"
  },
  {
    "companyName": "Amazon",
    "focuses": "Product Design, User Experience Design, UX Writing",
    "positionTypes": [
      "Full-time employees"
    ],
    "website": "www.amazon.com",
    "interviews": "No",
    "virtualTimes": "10:00 - 10:30, 10:30 - 11:00, 11:00 - 11:30, 11:30 - 12:00",
    "inPersonTimes": "",
    "logoUrlCheckString": "https://images.app.goo.gl/BhWDGMAA9qP3froJ9"
  },
  {
    "companyName": "Captiv Studios ",
    "focuses": "Virtual Production ",
    "positionTypes": [
      "Interns",
      "Full-time employees",
      "Part-time employees",
      "Contract workers",
      "Freelancers"
    ],
    "website": "https://www.captivstudios.com/",
    "interviews": "Yes",
    "virtualTimes": "All Day",
    "inPersonTimes": "",
    "logoUrlCheckString": "https://drive.google.com/file/d/1wtwjDwzGuUo8e9MK00lGu9D9QWs_S-DJ/view?usp=drive_link"
  },
  {
    "companyName": "Electronic Arts",
    "focuses": "Game Development",
    "positionTypes": [
      "Interns",
      "Full-time employees",
      "Contract workers"
    ],
    "website": "https://www.ea.com/",
    "interviews": "No",
    "virtualTimes": "All Day",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "https://www.dropbox.com/scl/fi/no3qn6gk0q2pj7gsg70t3/EA_Logo_Hero.png?rlkey=t7mi0e5she3jdl5sv3txt6vj8&st=6bb3clzp&dl=0"
  },
  {
    "companyName": "PBK Architects",
    "focuses": "Architecture",
    "positionTypes": [
      "Full-time employees"
    ],
    "website": "https://pbk.com/",
    "interviews": "Yes",
    "virtualTimes": "All Day",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "https://drive.google.com/drive/folders/1O0JIEF0nLGE9ifw8xxfu-VmUjQStQj_w?usp=drive_link"
  },
  {
    "companyName": "Angus Animation",
    "focuses": "Animation",
    "positionTypes": [
      "Members"
    ],
    "website": "AngusAnimation.com",
    "interviews": "No",
    "virtualTimes": "",
    "inPersonTimes": "All Day",
    "logoUrlCheckString": "https://drive.google.com/drive/folders/1X79N1YFFQZawgOMNwiQ3wXcBPc52Biom?usp=sharing"
  },
  {
    "companyName": "Amerra, Inc.",
    "focuses": "Animation, Game Development, Graphic Design, AR / VR",
    "positionTypes": [
      "Interns",
      "Part-time employees",
      "Contract workers",
      "Freelancers"
    ],
    "website": "www.amerra.com",
    "interviews": "No",
    "virtualTimes": "",
    "inPersonTimes": "10:00 - 10:30, 10:30 - 11:00, 11:00 - 11:30,  11:30 - 12:00, 12:00 - 12:30, 12:30 - 1:00",
    "logoUrlCheckString": "https://www.amerra.com/signature/amerralogo.png"
  },
  {
    "companyName": "The Stronghold Companies",
    "focuses": "Animation, Graphic Design, Basic Photography/Videography",
    "positionTypes": [
      "Interns",
      "Freelancers"
    ],
    "website": "thestrongholdcompanies.com",
    "interviews": "No",
    "virtualTimes": "11:30 - 12:00, 12:30 - 1:00, 1:00 - 1:30, 1:30 - 2:00, 2:00 - 2:30",
    "inPersonTimes": "",
    "logoUrlCheckString": "Option 2"
  },
  {
    "companyName": "Strand Architecture and Engineering",
    "focuses": "Architectural Visualization",
    "positionTypes": [
      "Interns",
      "Full-time employees"
    ],
    "website": "https://www.strandae.com/",
    "interviews": "Yes",
    "virtualTimes": "All Day",
    "inPersonTimes": "",
    "logoUrlCheckString": "https://drive.google.com/file/d/1RS4psIL61JvDXXa6SNB5EW9GKemnmOPl/view?usp=sharing"
  },
  {
    "companyName": "MOREgroup (Huckabee)",
    "focuses": "Animation",
    "positionTypes": [
      "Interns",
      "Full-time employees",
      "Part-time employees"
    ],
    "website": "moregroup-inc.com",
    "interviews": "Yes",
    "virtualTimes": "",
    "inPersonTimes": "11:30 - 12:00, 12:30 - 1:00, 1:00 - 1:30, 1:30 - 2:00, 2:00 - 2:30, 3:00 - 3:30",
    "logoUrlCheckString": "https://www.godspeed.com/investments/huckabee/"
  }
]`);
/**** GEN:E id="companies-csv" */

// edit manually
export const pastCompanies: string[] = Array.from(new Set([
  "900lbs",
  "A Bunch Of Short Guys",
  "AEM Creations",
  "Aggieland Outfitters",
  "Bluepoint Games",
  "BonusXP",
  "Booz Allen Hamilton, Inc.",
  "C.C. Creations",
  "Cinevva",
  "Click Here Labs - TRG",
  "Cloud Imperium Games",
  "Credera",
  "Deloitte",
  "Digital Seat Media",
  "DreamWorks Animation",
  "Electronic Arts",
  "Framestore",
  "Game Worlds",
  "Gearbox Software",
  "IMG Studio",
  "Jacobs Architects",
  "Mighty Coconut",
  "Pixar",
  "Powerhouse Animation",
  "ReelFX",
  "Six Foot Games",
  "Texas Film Commission",
  "Texas Moving Picture Alliance (TXMPA)",
  "The Third Floor, Inc.",
  "TRG",
  "Walt Disney",
  "Viasat",
]));
pastCompanies.sort((a, b) => a.toLowerCase() <= b.toLowerCase() ? -1 : 1);
